<template>
    <div>
      <create-eInvoice-list></create-eInvoice-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>